var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPiiDataType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-pii-data-type_svg__clip0_816_14695)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.455 1.982a4.26 4.26 0 012.827 1.17L18.23 12.1c.326.328.567.73.701 1.173a.202.202 0 00.337.081l.537-.536a1.627 1.627 0 000-2.3l-8.947-8.947A3.05 3.05 0 008.895.76H4.828a1.622 1.622 0 00-1.464.93.203.203 0 00.184.29h2.907z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.523 19.806a1.61 1.61 0 001.15.478 1.615 1.615 0 001.15-.476l2.441-2.44 2.104-2.104a1.627 1.627 0 000-2.3L8.42 4.018a3.05 3.05 0 00-1.965-.815H2.388A1.627 1.627 0 00.761 4.829v4.067c.027.73.315 1.428.814 1.963l8.948 8.947zM5.235 6.457a1.22 1.22 0 110 2.44 1.22 1.22 0 010-2.44z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-pii-data-type_svg__clip0_816_14695"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.761 .761)",
    d: "M0 0h19.523v19.523H0z"
  })))));
}
export default SvgIconPiiDataType;